import React, { useState } from 'react';
import DialogClearStyles, { DialogContent } from 'components/accounts/DialogClearStyles';
import SelectorButton from 'components/v2/buttons/SelectorButton';
import useIsReadOnlyMode from 'components/v2/compiler/hooks/useIsReadOnlyMode';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { HeaderDialog } from 'styles/Styles.styled';
import { Option } from 'types/types';
import AdminEditToolHeadCompanySelectorForm from './AdminEditToolHeadCompanySelectorForm';

interface Props {
  name: string;
  value: Option | null;
  onChanged(propertyName: string, newValue: Option | null): void;
  label: string;
  error?: string;
  addButtonText: string;
}

const AdminEditToolHeadCompanySelector: React.FC<Props> = ({ name, value, onChanged, label, error, addButtonText }) => {
  const isReadOnly = useIsReadOnlyMode();
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);

  return (
    <div>
      <SmartLabel label={label} error={error} />

      <SelectorButton
        name={name}
        value={value?.label ?? ''}
        placeholder="Add company"
        addButtonText={addButtonText}
        addButtonDisabled={!!value}
        onOpenSelector={() => setIsDialogVisible(true)}
        showDeleteButton={!!value && !isReadOnly}
        onDeleteClicked={() => onChanged(name, null)}
        disabled={isReadOnly}
      />

      <DialogClearStyles
        visible={isDialogVisible}
        onHide={() => setIsDialogVisible(false)}
        header={<HeaderDialog>Add company</HeaderDialog>}
        closable={false}
        draggable={false}
      >
        <DialogContent>
          <AdminEditToolHeadCompanySelectorForm
            initialValue={value}
            onSubmit={(newCompany) => {
              setIsDialogVisible(false);

              if (!newCompany) {
                return;
              }
              onChanged(name, newCompany);
            }}
          />
        </DialogContent>
      </DialogClearStyles>
    </div>
  );
};

export default AdminEditToolHeadCompanySelector;
